<template>
    <span>
         <v-btn icon class="mx-0" @click="deletemov()">
                      <v-icon color="pink">delete</v-icon>
          </v-btn>
   </span>
</template>

<script>
import {deleteModuleWithAttachment,getLinkedMov} from '@/model';
import moment from 'moment';

export default {
    name: 'DeleteMovie',
    props:{
        name :{
            required:true
        },
         movName :{
            required:true
        },
        category :{
            required:true
        }
    },
    data() {
        return {
           
         
        };
    },
    methods: {
        deletemov() {
            let self=this;
            let confirmed =  confirm('Warning!!! \n This will delete all movies in the campuses attached to this, do you continue?','Exodus','Yes','No');
    
            if(confirmed){
            
            let datenow = moment().format('DD/MM/YYYY');
            console.log(datenow);
            
             getLinkedMov('campus','category',self.category,'movName',self.movName,function(res){
                if(res.value==true){
                   alert("Please you can't edit nor delete a category after it has been linked to a campus.\n First unlink the movie from all campuses it is attached to.");
                 }else{
              
            deleteModuleWithAttachment('movie',self.name,function(response){
              if(response){
                    console.log("This is response: ",response);
                    
                   self.$store.dispatch('updateMovies',true);
                    alert('This has been successfully deleted movie');
                    
                  }else{
                      console.log(null);
                  }

              });
}})
                          }
        }
    }
};
</script>

<style scoped>
</style>